

import { Component, OnInit, ViewChild } from '@angular/core';
import { Designationmaster } from 'src/app/Models/Designationmaster';
import { ApiService } from 'src/app/Service/api.service';
// import { DepartmentcalenderComponent } from '../departmentcalender/departmentcalender/departmentcalender.component';
import { CookieService } from 'ngx-cookie-service';
import { DepartmentworkingDetails } from 'src/app/Models/departmentworking-details';
import { TickRole } from 'src/app/Models/tickrole';
import { NgForm } from '@angular/forms';
import { FeatureMaster } from 'src/app/Models/Feature';
import { NzNotificationService } from 'ng-zorro-antd';

@Component({
  selector: 'app-features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.css']
})
export class FeaturesComponent implements OnInit {

  formTitle = "Manage Feature";
  pageIndex = 1;
  pageSize = 10;
  totalRecords = 1;
  dataList = [];
  Roles = []
  loadingRecords = true;
  sortValue: string = "desc";
  sortKey: string = "ID";
  searchText: string = "";
  filterQuery: string = "";
  isFilterApplied: string = "default";
  columns: string[][] = [ ["NAME", "Name"], ["SHORT_CODE", "Short Code"]]
  // @ViewChild(DepartmentcalenderComponent, { static: false }) departmentCalender: DepartmentcalenderComponent;
  //drawer Variables
  drawerVisible: boolean;
  drawerTitle: string;
  drawerData: FeatureMaster = new FeatureMaster();
  applicationId = Number(this.cookie.get('applicationId'))
  drawerVisible1: boolean;
  drawerTitle1: string;
  drawerData1: FeatureMaster = new FeatureMaster();
  listOfData: DepartmentworkingDetails[] = [];
  OPEN_TIME2 = null
  CLOSE_TIME2 = null
  DAYS = false;
  ROLES = [];
  isSpinning = false
  constructor(private api: ApiService, private cookie: CookieService, private message: NzNotificationService) { }
  ngOnInit() {
    this.search();
  }
  // Basic Methods
  sort(sort: { key: string; value: string }): void {
    this.sortKey = sort.key;
    this.sortValue = sort.value;
    this.search(true);
  }
  search(reset: boolean = false) {
    var filter = ""
    if (reset) {
      this.pageIndex = 1;
    }
    this.loadingRecords = true;
    var sort: string;
    try {
      sort = this.sortValue.startsWith("a") ? "asc" : "desc";
    } catch (error) {
      sort = "";
    }
    console.log("search text:" + this.searchText);
    if (this.searchText != "") {
      var likeQuery = " AND";
      this.columns.forEach(column => {
        likeQuery += " " + column[0] + " like '%" + this.searchText + "%' OR";
      });
      likeQuery = likeQuery.substring(0, likeQuery.length - 2)

    }
    console.log(likeQuery)
    if (likeQuery)
      filter += likeQuery


    console.log(filter)

    this.api.getAllFeature(this.pageIndex, this.pageSize, this.sortKey, sort, filter).subscribe(data => {
      console.log(data['data'])
      this.loadingRecords = false;
      this.totalRecords = data['count'];
      this.dataList = data['data'];
    }, err => {
      console.log(err);
    });
  }
  //Drawer Methods
  get closeCallback() {
    return this.drawerClose.bind(this);
  }
  get closeCallback1() {
    return this.drawerClose1.bind(this);
  }
  add(): void {
    this.drawerTitle = "Create New Feature";
    this.drawerData = new FeatureMaster();
    this.listOfData = []
    
    this.api.getAllFeature(1,1,'SEQUENCE_NO','desc','').subscribe (data =>{
      if (data['count']==0){
        this.drawerData.SEQUENCE_NO=1;
      }else
      {
        this.drawerData.SEQUENCE_NO=Number(data['data'][0]['SEQUENCE_NO'])+1;
      }
      this.drawerVisible = true;
    },err=>{
      console.log(err);
    })
     
    this.drawerData.NAME==null;
    
    // this.api.getAllFeature(1, 1, 'SEQUENCE_NO', 'asc', '').subscribe(data => {
    //   if (data['count'] == 0) {
    //     this.drawerData.SEQUENCE_NO = 1;
    //   } else {
    //     this.drawerData.SEQUENCE_NO = Number(data['data'][0]['SEQUENCE_NO']) + 1;
    //   }
    // }, err => {
    //   console.log(err);
    // })
    
    for (let i = 0; i < 7; i++) {
      this.listOfData.push({
        ID: 0,
        DAY: i,
        IS_HOLIDAY: false,
        OPEN_TIME: null,
        CLIENT_ID: this.api.clientId,
        DEPARTMENT_ID: 0,
        DATE: "",
        CLOSE_TIME: null
      });
    }
    this.OPEN_TIME2 = null
    this.CLOSE_TIME2 = null
    this.DAYS = false;
    this.drawerVisible = true;
  }
  edit(data: FeatureMaster): void {
    this.drawerTitle = "Update Feature";
    this.drawerData = Object.assign({}, data);
    this.drawerVisible = true;
  }

  open(data: FeatureMaster): void {
    this.drawerTitle1 = "Features Role Mapping";
    // console.log("start time:"+data.DAY_START_TIME);
    this.drawerData1 = Object.assign({}, data);
    this.drawerVisible1 = true;
    this.api.getAllRoles(this.pageIndex, this.pageSize, this.sortKey, '', '').subscribe(data => {


      this.Roles = data['data'];
    }, err => {
      console.log(err);
    });
  }
  // close(): void {
  //   this.visible = false;
  // }
  close1(accountMasterPage:NgForm): void {
    this.drawerVisible1 = false;
    this.resetDrawer(accountMasterPage)
  }
  resetDrawer(accountMasterPage: NgForm) {
    accountMasterPage.form.reset();

  }
  // viewCalender(data: Department): void {
  //   console.log(data)
  //   this.drawerTitle1 = "Calender For " + data.NAME + "";
  //   this.drawerData1 = Object.assign({}, data);
  //   this.drawerVisible1 = true;
  //   console.log(data.ID)
  //   // this.departmentCalender.applyFilter(data.ID)
  // }
  save1(): void {
    var d = []
    if (this.ROLES != undefined && this.ROLES.length > 0) {
      for (var i = 0; i < this.ROLES.length; i++) {
        d.push({
          CLIENT_ID:1,
          FEATURE_ID: this.drawerData1.ID,
          ROLE_ID: this.ROLES[i],
          STATUS: true
        })
      }
      this.isSpinning = true;

      this.api.featuresRoleMapping(d,this.drawerData1.ID)
        .subscribe(successCode => {
          this.isSpinning = false;
          if (successCode['code'] == "200") {

            this.message.success("Role Mapping Updated Successfully...", "");
            this.ROLES=[];
            this.drawerClose1();
          }
          else {
            this.message.error("Role Mapping Updation Failed...", "");
            // this.isSpinning = false;
          }
        });
    } else {

      this.message.error("Please Select Roles...", "");

    }

  }
  drawerClose(): void {
    this.search();
    this.drawerVisible = false;
  }

  drawerClose1(): void {
    this.drawerVisible1 = false;
  }

}